module.exports = __webpack_public_path__ + "media/images/brandlogo-white-d52fc3d2c85d8034618b97996f6b638b.svg";